import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-image-section-card',
  templateUrl: './image-section-card.component.html',
  styleUrls: ['./image-section-card.component.scss'],
})
export class ImageSectionCardComponent  implements OnInit {

  @ViewChild('imgTemplate') imgTemplate: ElementRef;

  @Input() title: string;
  @Input() subTitle: string;
  @Input() imageUrl: string;
  @Input() contain: boolean;
  @Input() showArrow: boolean;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  constructor() { }

  ngOnInit() {}

}
